import { MouseEvent } from 'react';

import Image from 'global/Image';
import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';

import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';
import useUIConfigStore from 'stores/useUIConfigStore';

import {
  ActionWrapper,
  CancelButton,
  Container,
  ImageContainer,
  ContentWrapper,
  Description,
  NextButton,
  Title,
} from './onboarding.styled';

const CreatePortoOnboardinng = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const setUIValue = useUIConfigStore((s) => s.setUIValue);

  const handleDismiss = () => {
    setUIValue('multiPortfolioOnboardingEligible', true);
  };

  const handleSubmit = () => {
    onSubmit();
    handleDismiss();
  };

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
    handleDismiss();
  };

  return (
    <BaseSecuritiesModal hideSubmit onCancel={handleCancel} {...props}>
      <Container onClick={(e) => e.stopPropagation()}>
        <ImageContainer>
          <Image
            src="/images/multi-porto/onboarding.svg"
            alt=""
            width={420}
            height={250}
          />
        </ImageContainer>

        <ContentWrapper>
          <Title>Multiple Portfolio</Title>
          <Description>
            Buat portfolio baru untuk mengoptimalkan strategi investasi kamu.
          </Description>
        </ContentWrapper>

        <ActionWrapper>
          <NextButton onClick={handleSubmit} type="primary">
            Buat Portfolio Baru
          </NextButton>
          <CancelButton onClick={handleCancel}>Nanti Aja</CancelButton>
        </ActionWrapper>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default CreatePortoOnboardinng;
